import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
        path: 'dashboard',
        loadChildren: () => import('src/app/modules/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'feeds',
        loadChildren: () => import('src/app/modules/feeds/feeds.module').then(m => m.FeedsModule)
    },
    {
        path: 'transactions',
        loadChildren: () => import('src/app/modules/transactions/transactions.module').then(m => m.TransactionsModule)
    },
    {
        path: 'reports',
        loadComponent: () => import('./modules/reports/reports.component').then(m => m.ReportsComponent)
    },
    {
        path: 'account',
        loadChildren: () => import('src/app/modules/account/account.module').then(m => m.AccountModule)
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
